import { TEventSpecificData } from './constants/event_types/base_mable_event';

/**
 * Enum for the WTag actions
 */
export enum EWTagActions {
  Config = 'config', // init
  Consent = 'consent', // register specify consent for certain destinations and attach it to event
  Event = 'event',
  Get = 'get', // e.g. get anonId to inject in shopify bundle
  Set = 'set', //
}

/**
 * Type for the WTag
 */
export type ETWTag = {
  actionDetails:
    | TConfigAction
    | TConsentAction
    | TEventAction
    | TGetAction
    | TSetAction;
  actionName: string;
  dataLayerKey?: string; // dataLayer name
};

// specify wrapper functions which maps positional arguments on object keys

type TConsentAction = {
  consent: boolean;
  destinations: EDestinationType[];
};

type TGetAction = {
  key: string;
};

type TSetAction = {
  key: string;
  value: any;
};

type TConfigAction = {
  clientId: string; // shop
  dataLayerKey?: string; // dataLayer name
  tracking_status?: boolean;
};

export type DestinationSetting = {
  active: boolean;
  config?: Record<string, any>;
  id: number | string;
  setting?: DestinationSetting;
  type: EDestinationType;
};

export type TEventAction = {
  eventData: TEventSpecificData;
  // different for different events
  eventName: string;
};

export enum EDestinationType {
  Example = 'example',
  Facebook = 'facebook',
  GA4 = 'GA4',
  GoogleAds = 'googleads',

  // Server Destinations
  GoogleAnalytics = 'googleanalytics',
  GTM = 'GTM',
  Identify = 'identify', // ?
  // Mable Destinations
  Mable = 'mable',
  Pinterest = 'pinterest',
  SGTM = 'sgtm',
  TikTok = 'tiktok',
}
